import React from 'react';

import classNames from 'classnames';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { Checkbox } from '@bringg/react-components';
import { RoutesPlannerTask } from '@bringg-frontend/eta-calculator';

import { UpdatingSource } from '../../../../../types';
import { RouteRowTranslations } from '../../../../../routes-planner/translations';

import './select-cell.scss';

interface Props {
	isLocked: boolean;
	translations: RouteRowTranslations;
	checked: boolean;
	indeterminate: boolean;
	runId: number;
	tasksById: Map<number, RoutesPlannerTask>;
	selectedTasksIds: number[];
	changeTasksSelection: (tasksIds: number[], source: UpdatingSource) => void;
	onSelect: any;
}

const SelectCell = ({
	isLocked,
	translations,
	checked,
	indeterminate,
	runId,
	tasksById,
	selectedTasksIds,
	changeTasksSelection,
	onSelect
}: Props) => {
	const stopPropagation = e => {
		e.stopPropagation();
	};

	const handleCheck = e => {
		const firstSelectedTask = tasksById.get(selectedTasksIds[0]);
		if (firstSelectedTask && firstSelectedTask.run_id === runId && !e.target.checked) {
			changeTasksSelection([], UpdatingSource.PlannerTable);
		}
		onSelect([runId], e.target.checked);
	};

	return (
		<div className="route-row-item select-container">
			{isLocked ? (
				<div className="lock-container" data-tip={translations.moveUnassignToTimelineIsLocked}>
					<BringgIcon iconName={BringgFontIcons.Lock} />
				</div>
			) : (
				<div className="checkbox-container">
					<label htmlFor="eye-checkbox" className="checkbox-label">
						<Checkbox
							checked={checked}
							indeterminate={indeterminate}
							onClick={stopPropagation}
							onChange={handleCheck}
							className="route-row-checkbox"
							data-test-id="route-row-checkbox-input"
							id="eye-checkbox"
						/>
						<BringgIcon
							iconName={checked ? BringgFontIcons.Eye : BringgFontIcons.EyeOff}
							className={classNames('checkbox-icon', { 'eye-off': !checked })}
						/>
					</label>
				</div>
			)}
		</div>
	);
};

export default SelectCell;
